import { TRACK_CREATE_STOCK_REQUEST } from '~/redux/actions/types'

export const trackCreateStockRequest = (email, sku) => {
  return {
    type: TRACK_CREATE_STOCK_REQUEST,
    email,
    sku
  }
}
